<app-form-page [content]="content" />

<ng-template #content>
  <div class="m-t-5 m-b-3 text-align-center">
    <svg-icon
      role="img"
      src="assets/images/aptem-assess-logo-content.svg"
      data-ua-id="landing-page-logo"
    >
    </svg-icon>
  </div>

  <h2 class="text-bold m-b-3 text-align-center">
    <app-content
      [key]="pageHeadingKey"
      [value]="pageHeadingValue$ | async"
      [trackingId]="pageHeadingKey"
    >
      <span defaultContent> Your invite is on the way</span>
    </app-content>
  </h2>
  <app-content
    [key]="pageBodyKey"
    [value]="pageBodyValue$ | async"
    [trackingId]="pageBodyKey"
  >
    <p defaultContent>
      Thank you for providing your details. A unique invitation link is on its way to you. Please remember to check your
      junk email folder.
    </p>
  </app-content>
  <div>
    <svg-icon
      src="assets/images/registration-completed.svg"
      [svgStyle]="{ 'width.px': 325, 'height.px': 223 }"
    >
    </svg-icon>
  </div>
</ng-template>
